var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":("" + _vm.size),"height":("" + _vm.size)}},[_c('use',{attrs:{"xmlns:xlink":"http://www.w3.org/1999/xlink","xlink:href":(_vm.basePath + "#" + _vm.name)}})])}
var staticRenderFns = []

export { render, staticRenderFns }